var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24/package") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1.4039746 C11.4282032,0.868076211 12.5717968,0.868076211 13.4961389,1.40175686 L13.4961389,1.40175686 L20.5,5.40397429 C20.8744952,5.62018902 21.1909859,5.91039418 21.4353116,6.25015952 C21.4958723,6.31091827 21.5502485,6.38086421 21.5956073,6.45927644 C21.6332843,6.52440919 21.6627956,6.59202306 21.684458,6.66093236 C21.8878064,7.06975955 21.9995149,7.52681223 22,8 L22,8 L22,16.0010257 C21.9989013,17.0717233 21.4272516,18.0606772 20.4961389,18.5982431 L20.4961389,18.5982431 L13.5,22.5960254 C13.1776822,22.7821157 12.8293922,22.9035863 12.4733293,22.96053 C12.3331483,23.0367658 12.1716231,23.08 12,23.08 C11.8287836,23.08 11.6676173,23.0369705 11.5267251,22.9611355 C11.1717381,22.9043519 10.8246003,22.783426 10.5038611,22.5982431 L10.5038611,22.5982431 L3.5,18.5960257 C2.57274841,18.0606772 2.00109875,17.0717233 2,16 L2,16 L2,7.99897429 C2.00048311,7.52819608 2.11127079,7.07322136 2.31409111,6.66566055 C2.33606137,6.59464978 2.36598414,6.5256739 2.40439274,6.45927644 C2.44975148,6.38086421 2.50412769,6.31091827 2.56545248,6.24999112 C2.80901406,5.91039418 3.1255048,5.62018902 3.5,5.40397429 L3.5,5.40397429 L6.75457579,3.54310651 C6.90151426,3.37852815 7.09603275,3.27091172 7.30456308,3.22927023 Z M3.999,8.53677316 L3.99999947,15.9989743 C4.00036555,16.3558735 4.19091543,16.6855248 4.49613894,16.8617569 L4.49613894,16.8617569 L11,20.5787732 L11,12.5857732 L3.999,8.53677316 Z M19.999,8.53677316 L13,12.5857732 L13,20.5767732 L19.4999995,16.8639743 C19.7747418,16.7053525 19.9558266,16.4272626 19.9929322,16.1174819 L19.9999995,16 L19.999,8.53677316 Z M7.55,5.39277316 L5.039,6.82777316 L12,10.854 L14.506,9.40377316 L7.55,5.39277316 Z M12.4999995,3.1360254 C12.1905989,2.95739261 11.8094011,2.95739261 11.4961389,3.13824314 L11.4961389,3.13824314 L9.561,4.24377316 L16.505,8.24777316 L18.96,6.82777316 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/package",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.b4c322a0fd91bb183c62d15af3d34804.svg";
export { ForwardRef as ReactComponent };